<template>
  <div class="home">
    <menu_div></menu_div>
  </div>
  <div class="main-content">
    <div class="left-section">
      <div class="content">
        <h2>最新动态</h2>
      </div>
      <div class="menu_content">
        <div class="news-list">
          <div 
            v-for="news in newsList" 
            :key="news.id" 
            class="news-item"
            @click="goToNewsDetail(news)"
          >
            <div class="news-content">
              <el-image 
                v-if="news.image" 
                :src="news.image" 
                fit="cover"
                class="news-image"
              />
              <h3>{{ news.title }}</h3>
              <p>{{ news.content }}</p>
              <span class="news-time">{{ news.updateTime }}</span>
            </div>
          </div>
          <div v-if="newsList.length === 0" class="no-content">
            暂无新闻
          </div>
        </div>
      </div>
    </div>
    <div class="right-section">
      <div class="content">
        <h2>游戏特色&原创内容</h2>
      </div>
      <div class="menu_content">
        <div class="menu_ul">
          <div class="spec">
            <img src="../../assets/img/home/family.png" alt="" />
            <h3>更具吸引力的家族系统</h3>
          </div>
          <p>
            Wings改变了家族的创建和升级方式，加入了BOSS信物概念。同时随着家族常驻技能的加入，家族的功能性被增强了。家族不再仅仅是一个聊天的群组，建设它将带给玩家更多的成就感和实际的提升。
          </p>
        </div>
        <div class="menu_ul">
          <div class="spec">
            <img src="../../assets/img/home/plug.png" alt="" />
            <h3>游戏插件和使用功能</h3>
          </div>
          <p>
            技术研发是提高游戏体验的重要方式，目前已实装"掉线不清除BUFF"、"防卡功能（屏蔽发包）"、"实时经验统计"，同时实现了客户端的自动更新，我们将持续开发更多实用功能。
          </p>
        </div>
        <div class="menu_ul">
          <div class="spec">
            <img src="../../assets/img/home/support.png" alt="" />
            <h3>赞助的机制与公平性</h3>
          </div>
          <p>
            赞助点券在前期只能购买外观类物品和功能性道具。我们将在扎昆前推出百宝箱，百宝箱的所有物品将不会<strong>独占</strong>，这意味着每一件在百宝箱内的物品都在野外有掉落方式。它将为物价系统的合理稳定起到关键的作用。
          </p>
        </div>
        <div class="menu_ul">
          <div class="spec">
            <img src="../../assets/img/home/world.png" alt="" />
            <h3>渐变开放与世界等级</h3>
          </div>
          <p>
            WingsMS是一个基于渐变式内容的怀旧服务器，为了保证进度开放的合理、透明性，我们将控制权交给玩家,引入了"世界等级"机制，它将由活跃角色的加权平均等级决定。随着世界等级的提升，相关的游戏机制如三转、四转等将会自动解锁。
          </p>
        </div>
        <div class="menu_ul">
          <div class="spec">
            <img src="../../assets/img/home/server.png" alt="" />
            <h3>服务器的稳定性概述</h3>
          </div>
          <p>
            WingsMS采用了成熟的安全解决方案，从服务器到赞助渠道都进行了严格的筛选，虽然这确实会为赞助渠道增加门槛。我们的团队分布在海外各地，可以为玩家提供7*24小时的服务。
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="player-guides">
    <h2>玩家攻略</h2>
    <div class="guide-list">
      <div 
        v-for="guide in guideList" 
        :key="guide.id" 
        class="guide-item"
        @click="goToGuideDetail(guide)"
      >
        <div class="guide-content">
          <el-image 
            v-if="guide.image" 
            :src="guide.image" 
            fit="cover"
            class="guide-image"
          />
          <h3>{{ guide.title }}</h3>
          <p>{{ guide.content }}</p>
          <span class="guide-time">{{ guide.updateTime }}</span>
        </div>
      </div>
      <div v-if="guideList.length === 0" class="no-content">
        暂无攻略
      </div>
    </div>
  </div>
</template>

<script>
import menu_div from "@/components/common/menu_div";
import { ref, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';

export default {
  name: "Home",
  components: {
    menu_div,
  },
  setup() {
    const router = useRouter();
    const newsList = ref([]);
    const guideList = ref([]);

    // 从本地存储获取内容
    const loadContent = () => {
      const contentList = JSON.parse(localStorage.getItem('contentList') || '[]');
      newsList.value = contentList
        .filter(item => item.type === 'news' && item.status === 'published')
        .sort((a, b) => new Date(b.updateTime) - new Date(a.updateTime))
        .slice(0, 3); // 只显示最新的3条新闻

      guideList.value = contentList
        .filter(item => item.type === 'guide' && item.status === 'published')
        .sort((a, b) => new Date(b.updateTime) - new Date(a.updateTime))
        .slice(0, 3); // 只显示最新的3条攻略
    };

    // 查看新闻详情
    const goToNewsDetail = (news) => {
      router.push({
        name: 'NewsDetail',
        params: { id: news.id }
      });
    };

    // 查看攻略详情
    const goToGuideDetail = (guide) => {
      router.push({
        name: 'GuideDetail',
        params: { id: guide.id }
      });
    };

    onMounted(() => {
      loadContent();
    });

    return {
      newsList,
      guideList,
      goToNewsDetail,
      goToGuideDetail
    };
  }
};
</script>

<style scoped>
.main-content {
  display: flex;
  gap: 20px;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.left-section {
  flex: 0 0 300px;
}

.right-section {
  flex: 1;
}

.menu_content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.menu_ul {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
}

/* 可点击的卡片样式 */
.left-section .menu_ul {
  cursor: pointer;
  border: 1px solid #e0e0e0;
  background: #f8f9fa;
}

.left-section .menu_ul:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
  border-color: #007bff;
  background: #fff;
}

/* 不可点击的卡片样式 */
.right-section .menu_ul {
  cursor: default;
  border: 1px solid #f0f0f0;
}

.right-section .menu_ul:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.menu_ul h3 {
  font-weight: 600;
  color: #494f51;
  line-height: 36px;
  margin-left: 6px;
}

.menu_ul img {
  max-width: 36px;
}

.spec {
  display: flex;
  align-items: center;
}

.menu_ul p {
  font-size: 14px;
  font-weight: 400;
  color: #919ca8;
  line-height: 24px;
  margin-top: 10px;
}

.content h2 {
  font-weight: 800;
  color: #000000;
  text-align: center;
  margin-bottom: 20px;
}

.news-date, .guide-meta {
  font-size: 12px;
  color: #666;
  margin-top: 10px;
  text-align: right;
}

.guide-meta {
  display: flex;
  justify-content: space-between;
}

@media (max-width: 768px) {
  .main-content {
    flex-direction: column;
  }
  
  .left-section {
    flex: 1;
  }
  
  .menu_ul {
    flex-basis: 99%;
  }
}

.news-list, .guide-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.news-item, .guide-item {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 20px;
}

.news-item:hover, .guide-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
  border-color: #007bff;
}

.news-image, .guide-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 15px;
}

.news-content h3, .guide-content h3 {
  margin: 0 0 10px 0;
  color: #303133;
  font-size: 18px;
}

.news-content p, .guide-content p {
  margin: 0 0 10px 0;
  color: #606266;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-time, .guide-time {
  color: #909399;
  font-size: 14px;
}

.no-content {
  text-align: center;
  color: #909399;
  padding: 20px;
}
</style>